export enum EnumPerfilUsuario {
  Estudante = 1,
  Concurseiro = 2,
  Advogado = 3,
}
